var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$store.getters[_vm.filter.getter])?_c('the-dropdown',{attrs:{"selected-option":(_vm.filter.value || '').toString(),"text":_vm.filter.text,"options":_vm.$store.getters[_vm.filter.getter]},on:{"onChange":function($event){return _vm.$emit('set-filter', $event)}}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }